import request from '@/utils/request'
export const queryPage = '/icps/system/sign/cloudsell/custommanage/queryPage'
export const batchUpdateOrDelete = '/icps/system/sign/cloudsell/custommanage/deletes'
export const updateSortNum = ''
export const saveOrUpdate = '/icps/system/sign/cloudsell/custommanage/saveOrUpdate'
export const Download = '/icps/system/sign/cloudsell/custommanage/exportList'
export const OtherDownload = '/icps/system/sign/cloudsell/custommanage/exportExample'

/*获取所有普客户信息*/
export function querycustomerPage(data) {
  return request({
    url: '/icps/system/sign/cloudsell/custommanage/queryPage',
    method: 'post',
    data
  })
}
/*导入客户信息*/
export function ignore(data) {
  return request({
    url: '/icps/system/sign/cloudsell/custommanage/importList ',
    method: 'post',
    data
  })
}
/*合作工程*/
export function getEngineeringsByid(data) {
  return request({
    url: '/icps/system/sign/cloudsell/custommanage/getEngineeringsByid',
    method: 'post',
    data
  })
}
// 获取前账号所属公司下的客户组织
export function queryOragan(params) {
  return request({
    url:"/base/system/base/organization/queryOragan",
    method:"get",
    params
  })
}